export default "__VITE_ASSET__b957d938__"